import { render, staticRenderFns } from "./ReportSegment.vue?vue&type=template&id=066295e6&scoped=true"
import script from "./ReportSegment.vue?vue&type=script&lang=js"
export * from "./ReportSegment.vue?vue&type=script&lang=js"
import style0 from "./ReportSegment.vue?vue&type=style&index=0&id=066295e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066295e6",
  null
  
)

export default component.exports